import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
// Swap out any of these for Sarasota-specific shots
import heroImg   from '../images/tampa3.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image121.webp';
import slideImg2 from '../images/image117.webp';
import slideImg3 from '../images/image50.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const portTampaCityConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Port Tampa City Tree Service | Sam\'s Tree Service',
  metaDescription: 'Expert tree trimming and removal in Port Tampa City, FL. Sam\'s Tree Service handles dangerous trees safely and professionally.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_port_tampa_city',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Port Tampa City',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Port Tampa City Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we serve the working waterfront 
     neighborhood of <strong>Port Tampa City</strong> with dependable, 
     professional tree care. This historic South Tampa community sits at 
     the mouth of Tampa Bay making it one of the most storm exposed 
     residential areas in Hillsborough County. Trees here face relentless 
     salt air and wind, and when they become hazards, our team responds 
     with the skills and equipment to handle it safely.`,

    `We specialize in <strong>hazardous tree removal and targeted trimming 
     in coastal residential settings</strong> overhanging limbs near homes 
     and waterfront structures, storm split trunks, palms weakened by years 
     of salt exposure, and full removals on tight residential lots close 
     to the water. We work efficiently and clean up completely.`,

    `<strong>Sam's Tree Service</strong> provides reliable, affordable tree care 
     throughout <strong>Port Tampa City</strong> and the surrounding 
     <strong>South Tampa peninsula</strong> keeping your property 
     protected and your landscape maintained all year long.`,
  ],
  ctaLabel: 'Get a Free Estimate!',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Port Tampa City, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_PortTampaCity = () => <LocationPage config={portTampaCityConfig} />;
export default Services_PortTampaCity;
